import React, { useState, createRef, useEffect, FC }from 'react';
import { MainDataGrid } from "@/components/";
import { IFollowup } from "@interfaces/screens/followup.interface";
import FollowupPresenter from "../../../../presenters/screens/followup.presenter";
import styles from '../followup.module.scss';

interface IsubprojectsByProjectFollowUpProps{
    dataColumns: any,
}

const SubProjectByCountry: React.FC<IsubprojectsByProjectFollowUpProps> = (props) => {
    const [dataSource, setDataSource] = useState([]);

    const view: IFollowup = {
        state: {
            dataSource: dataSource,
            dataColumns: props.dataColumns,
            setDataSource: setDataSource
        },
    };

	const presenter = new FollowupPresenter(view);

    useEffect(() => {
        if(presenter.formMasters && presenter.followupData.length && presenter.params && Object.keys(presenter?.params)?.length && presenter.followupLabels?.values?.length && presenter.currentUser) presenter.getDataSubProjectsByProject(presenter.followupData, presenter.formMasters)
    }, [presenter.formMasters, presenter.followupData, presenter.params, presenter.followupLabels, presenter.followupLabels]);

    if(dataSource.length && props.dataColumns) 
        return (
            <>
                <div className={styles.mssUpdate}>{presenter.lastUpdateDate}</div>
                <MainDataGrid gridProps={presenter.getGridProps("table-followup-project")} tableId={"table-followup-project"} dataSource={dataSource} columns={presenter.getSubprojectsByProjectColumns()} base={"/followup/overlaps/project/"} ></MainDataGrid>
            </>
        )
    else return <div></div>
}

export default SubProjectByCountry;